let packageJson = require("../../package.json");

export default function TaxYear(props) {
	const taxYear = packageJson.taxYear;

	return props.previous ? <span>{taxYear - 1}</span> : <span>{taxYear}</span>;
}
